import React from 'react'
import { connect } from 'react-redux'
import { SEVERITIES } from './Auditor'
import { select, setActiveStep } from './DesignerActions'
import ExclamationIcon from '@tecuity/sos-icons/react/exclamation-point'
import CheckmarkIcon from '@tecuity/sos-icons/react/check'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'

class AuditErrorBoundary extends React.Component{
  state = {
    errored: false
  }
  componentDidCatch(err){
    console.error(err)
    this.setState({errored: true})
  }
  render(){
    const { children } = this.props;
    return (
      this.state.errored ?
      <div className="audit-logs">
        <EmptyState auditError />
      </div>
      :
      children
    )
  }
}

const EmptyState = ({ auditError }) => {
  return (
    <div className={`audit-empty-state ${auditError ? "audit-crashed" : ""}`}>
      <div className="check-icon animated zoomIn fast-animation">
        {
          auditError ?
          <CrossIcon />
          :
          <CheckmarkIcon />
        }
      </div>
      <div className="flex-column">
        <h3 className="animated fadeIn fast-animation">{auditError ? 'Something went wrong' : 'Looking good!'}</h3>
        <p className="animated fadeIn fast-animation">{auditError ? 'An error occured while auditing this Wizard and it was unable to continue.' : 'No problems were detected with this form.'}</p>
      </div>
    </div>
  )
}

let AuditPanel = ({ auditLogs = [], auditError }) => {
  return (
    <div className="audit-panel">
      <h3 className="title">Audit Results</h3>
      <AuditErrorBoundary>
        <div className="audit-logs">
          {auditLogs && auditLogs.length && !auditError ? (
            auditLogs.map((log, index) => <Log {...log} key={log.id} />)
          ) : (
            <EmptyState auditError={auditError} />
          )}
        </div>
      </AuditErrorBoundary>
    </div>
  )
}

export default connect(state => ({
  auditLogs: state.designer.auditLogs,
  auditError: state.designer.auditError
}))(AuditPanel)

export let Log = ({
  title,
  message,
  entityMap,
  severity,
  fields,
  sections,
  steps,
  stepOrder,
  select,
  setActiveStep,
  tabIndex,
  hideFooter
}) => {
  const getEntityDisplay = () => {
    switch (entityMap.type) {
      case 'OPTION':
      case 'CHECKBOX':
      case 'REPEATER':
      case 'FIELD':
        return [
          `Step: ${steps[entityMap.stepId].title}`,
          fields[entityMap.fieldId].label || 'Unlabeled Field',
          fields[entityMap.fieldId].name,
          // `Section: ${sections[entityMap.sectionId].title}`,
        ]
      case 'STEP':
        return [
          `Step: ${steps[entityMap.stepId].title}`
        ]
      default:
        return []
    }
  }

  const getSeverityName = () => {
    return Object.values(SEVERITIES).find(s => s.id === severity).name
  }

  const selectEntity = () => {
    switch (entityMap.type) {
      case 'REPEATER':
      case 'CHECKBOX':
      case 'OPTION': {
        const stepIndex = stepOrder.findIndex(x => x === entityMap.stepId)
        if (stepIndex >= 0) {
          setActiveStep(stepIndex)
        }
        select({
          type: 'FIELD',
          id: entityMap.parentFieldId
        })
        break;
      }
      case 'FIELD': {
        const stepIndex = stepOrder.findIndex(x => x === entityMap.stepId)
        if (stepIndex >= 0) {
          setActiveStep(stepIndex)
        }
        select({
          type: 'FIELD',
          id: entityMap.fieldId
        })
      }
        break;
      case 'STEP': {
        const stepIndex = stepOrder.findIndex(x => x === entityMap.stepId)
        if (stepIndex >= 0) {
          setActiveStep(stepIndex)
        }
        select({
          type: 'STEP',
          id: entityMap.stepId
        })
        break;
      }
      default:
    }
  }

  return (
    <div
      className={`audit-log-card ${getSeverityName()}`}
      tabIndex={tabIndex || 0}
      onClick={selectEntity}
    >
      <h4>{title}</h4>
      <p>{message}</p>
      {
        !hideFooter && (
          <div className="audit-log-card-footer">
            {getEntityDisplay().map((token, i) => (
              <span className="audit-log-card-footer-token" key={token + i}>
                {token}
              </span>
            ))}
          </div>
        )
      }
    </div>
  )
}

Log = connect(
  state => ({
    fields: state.designer.wizard.fields,
    sections: state.designer.wizard.sections,
    steps: state.designer.wizard.steps,
    stepOrder: state.designer.wizard.stepOrder
  }),
  {
    select,
    setActiveStep
  }
)(Log)

export const getLogSeverity = logs => logs.reduce((severity, log) => {
  if (log.severity > severity) return log.severity
  return severity
}, 0)

export const LogIcon = ({ logs, severity, size = '', children }) => {
  const logSeverity = severity !== undefined ? severity : getLogSeverity(logs)
  if (logSeverity > 5) {
    return (
      <React.Fragment>
        <span className={`panel-log-icon critical ${size}`}>
          <ExclamationIcon />
        </span>
        {
          typeof children === "function" ? children(logSeverity) : null
        }
      </React.Fragment>
    )
  }
  if (logSeverity === 4) {
    return (
      <React.Fragment>
        <span className={`panel-log-icon warning ${size}`}>
          <ExclamationIcon />
        </span>
        {
          typeof children === "function" ? children(logSeverity) : null
        }
      </React.Fragment>
    )
  }
  return null
}



// WEBPACK FOOTER //
// ./src/components/Designer2/AuditPanel.js